import { render, staticRenderFns } from "./NuevoAnticipo.vue?vue&type=template&id=22244008"
import script from "./NuevoAnticipo.vue?vue&type=script&lang=js"
export * from "./NuevoAnticipo.vue?vue&type=script&lang=js"
import style0 from "./NuevoAnticipo.vue?vue&type=style&index=0&id=22244008&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports